module.exports = __webpack_public_path__ + "static/media/un-favorite.1e3a732d.svg";